import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Tooltip as ReactTooltip } from 'react-tooltip';
import displayName from 'component-lib/displayName';
import TooltipGrayIcon from 'v-c/Icons/TooltipGrayIcon';
import styles from './Dropdowns.scss';

export default class DropdownFooterText extends Component {
    static displayName = displayName('Dropdowns/DropdownFooterText');

    static propTypes = {
        text: PropTypes.node.isRequired,
        tooltipText: PropTypes.string,
    };

    static defaultProps = {
        tooltipText: null,
    };

    renderTooltip() {
        if (!this.props.tooltipText) {
            return null;
        }

        return (
            <span>
                <TooltipGrayIcon
                    data-tip
                    data-for="dropdown-footer-text"
                    imageRef={(tooltip) => { this.tooltip = tooltip; }}
                    className={styles['help-icon']}
                />
                <ReactTooltip html id="dropdown-footer-text">
                    {this.props.tooltipText}
                </ReactTooltip>
            </span>
        );
    }

    render() {
        return (
            <span className={styles['dropdown-window-footer-text']}>
                {this.props.text}
                {this.renderTooltip()}
            </span>
        );
    }
}
